import * as React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useBoundStore } from "useStore";
import useTallerData from "../Queries/tallerDataQuery";
import { Stack, Typography } from "@mui/material";
import { slots, tableStyles } from "./Table/utils";

export default function Taller_Table({ onRowClick, country }) {
  const tallerDataQuery = useTallerData({ countryId: country.id });
  const dataTable = tallerDataQuery.data?.data ?? [];
  const dataCount = tallerDataQuery.data?.count ?? 0;

  const paginationModel = useBoundStore(
    (state) => state.soTallerPaginationModel,
  );
  const setPaginationModel = useBoundStore(
    (state) => state.setSoTallerPaginationModel,
  );

  return (
    <Box sx={{ width: "100%" }}>
      <DataGridPro
        rows={dataTable}
        loading={tallerDataQuery.isFetching}
        rowCount={dataCount}
        paginationMode="server"
        pagination={true}
        onPaginationModelChange={setPaginationModel}
        paginationModel={paginationModel}
        onRowClick={(params, _event, _details) => onRowClick(params.row)}
        disableColumnReorder
        disableColumnMenu
        disableColumnSorting
        disableColumnResize
        slots={slots}
        disableRowSelectionOnClick
        getRowId={(row) => row.id}
        columns={columns}
        sx={tableStyles}
      />
    </Box>
  );
}

const columns = [
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 0.5,
    minWidth: 80,
    field: "id",
    headerName: "ID",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 160,
    field: "envios_numero_de_seguimiento",
    headerName: "Número de envío",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 160,
    field: "ventas_num_de_venta",
    renderHeader: () => <Header texto="Número" texto2="de seguimiento" />,
    headerName: "Número de seguimiento",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 0.8,
    minWidth: 120,
    field: "date_created",
    headerName: "Fecha carga",
    valueGetter: (_, row) =>
      new Date(row.date_created).toISOString().split("T")[0],
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 0.8,
    minWidth: 130,
    field: "devoluciones_fecha_entregado",
    headerName: "Fecha devolución",
    valueGetter: (_, row) =>
      new Date(row.devoluciones_fecha_entregado).toISOString().split("T")[0],
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 120,
    field: "publicaciones_sku",
    headerName: "SKU",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 160,
    field: "origen_devolucion_name",
    headerName: "Origen Devolución",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 150,
    field: "deposito_destino_name",
    headerName: "Depósito destino",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 140,
    field: "condition_name",
    headerName: "Condición",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 1,
    minWidth: 120,
    field: "sintoma_name",
    headerName: "Síntoma",
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 0.5,
    minWidth: 120,
    field: "aceptamos_devolucion_name",
    //headerName: "Aceptamos la devolución",
    renderHeader: () => <Header texto="Aceptamos" texto2="la devolución" />,
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 0.6,
    minWidth: 120,
    field: "fecha_analisis_admin",
    headerName: "Fecha inicio análisis",
    renderHeader: () => <Header texto="Fecha" texto2="inicio análisis" />,
    valueGetter: (_, row) =>
      new Date(row.fecha_analisis_admin).toISOString().split("T")[0],
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    renderHeader: () => <Header texto="Movimiento" texto2="VS Inicial" />,
    align: "center",
    flex: 0.5,
    minWidth: 100,
    field: "movimientos_vs_inicial",
    headerName: "Movimiento VS. Inicial",
    valueGetter: (_, row) => (row.movimientos_vs_inicial ? "SI" : "NO"),
  },
  {
    headerAlign: "center",
    headerClassName: "header",
    align: "center",
    flex: 0.5,
    minWidth: 90,
    field: "action",
    headerName: "Acción",
    sortable: false,
    renderCell: () => (
      <Button
        sx={{
          color: "#002878",
          textTransform: "uppercase",
          "&:hover": { backgroundColor: "#00287844", color: "#002878" },
        }}
      >
        Abrir
      </Button>
    ),
  },
];
const Header = ({ texto, texto2 }) => (
  <Stack
    direction="column"
    alignItems="center"
    spacing={0.5}
    sx={{ height: "100%", fontSize: "14px", fontWeight: 500 }}
  >
    <Typography sx={{ fontWeight: 500 }}>{texto}</Typography>
    <Typography sx={{ fontWeight: 500 }}>{texto2}</Typography>
  </Stack>
);
